import React from "react";
import { AppEntities } from "../../../../config/entities";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { NewDocumentListView } from "../../../Shared/NewDocumentListView";
import { ListView } from "../../../Shared/ListViews/ListView";
import { ListviewToolbarMoreActions } from "../../../Shared/ListViews/ListviewToolbarMoreActions";
import { DocumentListViewToolbar } from "../../../Shared/ListViews/DocumentListViewToolbar";
import { DocumentListViewDefaultToolbarButtons } from "../../../Shared/ListViews/DocumentListViewDefaultToolbarButtons";

const SettlementVendorOpeningBalancesList = () => {
  const fields: IListViewField[] = [];

  return (
    <>
      <ListView
        fields={fields}
        entity={AppEntities.SettlementVendorOpeningBalances}
        createMoreActions={[]}
      >
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>
    </>
  );
};

export default SettlementVendorOpeningBalancesList;
